import React, { useState }from 'react'
import PropTypes from 'prop-types'
import { withStyles } from "@material-ui/core/styles";
import { Button, Input, Typography } from "@material-ui/core"
import UserService from "../service/user"
import UecareAlertDialog from "./UecareAlertDialog";
import ReduxGlobal from "../store/actionreducers/globalView";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const styles = () => ({
    textField: {
        fontSize: 22,
    },
})

const ChangePassword = ({
    classes,
    openErrorDialog,
}) => {
    const [ newPassword, setNewPassword ] = useState('')
    const [ confirmNewPassword, setConfirmNewPassword ] = useState('')
    const [ newPasswordMessage, setNewPasswordMessage ] = useState('')
    const [ confirmNewPasswordMessage, setConfirmNewPasswordMessage ] = useState('')

    const validatePassword = () => {
        if (!newPassword) return setNewPasswordMessage('新密碼不能為空')
        if (!newPassword.length) return setNewPasswordMessage('新密碼不能為空')
        if (!/^[A-Za-z0-9!#$%&'*+/=?^_`{|}~"(),\-.:;<>@\[\] \\]*$/.test(newPassword)) return setNewPasswordMessage('新密碼資料格式不符')
        if (newPassword.trim() !== newPassword) return setNewPasswordMessage('新密碼的開頭與結尾不可為空格')
        if (newPassword.length < 6) return setNewPasswordMessage('新密碼長度不能少於6')
        if (newPassword.length > 16) return setNewPasswordMessage('新密碼長度不能大於16')
        setNewPasswordMessage('')
        return true
    }

    const validateConfirmPassword = () => {
        if (!confirmNewPassword) return setConfirmNewPasswordMessage('確認密碼不能為空')
        if (!confirmNewPassword.length) return setConfirmNewPasswordMessage('確認密碼不能為空')
        if (confirmNewPassword !== newPassword) return setConfirmNewPasswordMessage('新密碼與確認密碼不一樣')
        setConfirmNewPasswordMessage('')
        return true
    }

    const onClickChangePassword = async() => {
        if (!validatePassword()) return
        if (!validateConfirmPassword()) return
        await UserService.changePassword({ newPassword })
        setNewPassword('')
        setConfirmNewPassword('')
        openErrorDialog({ title: '成功', message: '您的密碼已修改成功'})
    }

    return (
        <div className="flex justify-center items-center text-center">
            <div className="flex flex-col justify-start max-w-md">
                <div className="mb-24">
                    <Input
                        className={classes.textField}
                        value={newPassword}
                        onChange={e => setNewPassword(e.target.value)}
                        type="password"
                        placeholder="請輸入新密碼 (6-16位)"
                    />
                    {newPasswordMessage
                    && <Typography variant='caption' className='text-left text-red'>
                        {newPasswordMessage}
                    </Typography>
                    }
                </div>
                <div className="mb-24">
                    <Input
                        className={classes.textField}
                        value={confirmNewPassword}
                        onChange={e => setConfirmNewPassword(e.target.value)}
                        type="password"
                        placeholder="請確認您的新密碼"
                    />
                    {confirmNewPasswordMessage
                    && <Typography variant='caption' className='text-left text-red'>
                        {confirmNewPasswordMessage}
                    </Typography>
                    }
                </div>
                <Button
                    variant="outlined"
                    size="large"
                    onClick={() => onClickChangePassword()}
                >
                    修改密碼
                </Button>
        </div>
        <UecareAlertDialog />
    </div>)
}

ChangePassword.propTypes = {
    classes: PropTypes.object,
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openErrorDialog: ReduxGlobal.ActionCreator.openErrorDialog,
    }, dispatch)
}

export default withStyles(styles, {withTheme: true})(connect(null, mapDispatchToProps)(ChangePassword))



// WEBPACK FOOTER //
// ./src/components/ChangePassword.js